import { Typography } from "@mui/material";
import "./AddMember.css";
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FormModal from "../../../../Components/Molecules/FormModal/FormModal";
import AddCoachForm from "../../../../Components/Organisms/Forms/AddCoachForm/AddCoachForm";
import AddTeamForm from "../../../../Components/Organisms/Forms/AddTeamForm/AddTeamForm";
import AddMemberForm from "../../../../Components/Organisms/Forms/AddMemberForm/AddMemberForm";
import { PulseLoader } from "react-spinners";
import config from "../../../../config";

function AddMember({ url, editId, member }) {
  return (
    <div className="mainContainer">
      <div className="cont">
        <div className="greyBoxVer">
          <Typography
            sx={{
              color: "primary.main",
              fontSize: { xs: "28px", md: "35px" },
              fontWeight: "500",
              marginBottom: "5px",
            }}
          >
            {editId ? "Edit Member" : "Add New Member"}
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: "14px", md: "16px" },
              marginBottom: "20px",
            }}
          >
            {editId ? (
              <>
                Here, you can edit an existing member to your team for the{" "}
                <strong>
                  {config.APP_NAME == "Code Reg"
                    ? "Code Challenge Competition"
                    : config.APP_NAME == "WeDo Reg"
                    ? "WeDo Challenge Competition"
                    : "International Robot Challenge Competition"}
                </strong>
                .
              </>
            ) : (
              <>
                Here, you can add a new member to your team for the{" "}
                <strong>
                  {config.APP_NAME == "Code Reg"
                    ? "Code Challenge Competition"
                    : config.APP_NAME == "WeDo Reg"
                    ? "WeDo Challenge Competition"
                    : "International Robot Challenge Competition"}
                </strong>
                . Please fill in the required details accurately to ensure the
                member is successfully added to the team.
              </>
            )}
          </Typography>
          <Accordion
            sx={{
              boxShadow:
                "0px 0px 10px -1px rgba(0,0,0,0.2),0px 0px 1px -1px rgba(0,0,0,0.14),0px 1px 1px 0px rgba(0,0,0,0.12)",
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              Member Registration Guidelines & Steps
            </AccordionSummary>
            <AccordionDetails>
              <Typography
                sx={{
                  fontSize: { xs: "16px", md: "20px" },
                  fontWeight: "600",
                  marginTop: "10px",
                }}
              >
                Member Addition Guidelines:
              </Typography>
              <ol style={{ marginLeft: "30px" }}>
                <li>
                  Ensure the member's information is accurate and complete.
                </li>
                {config.APP_NAME == "Robot Reg" ? (
                  ""
                ) : (
                  <>
                    <li>
                      Members cannot participate in multiple teams or
                      categories.
                    </li>
                    <li>birth date must match official records.</li>
                  </>
                )}
              </ol>
              <Typography
                sx={{
                  fontSize: { xs: "16px", md: "20px" },
                  fontWeight: "600",
                  marginTop: "10px",
                }}
              >
                Steps to Add a New Member:
              </Typography>
              <ol style={{ marginLeft: "30px" }}>
                <li>
                  Enter the member's Full Name (as it appears on official
                  documents).
                </li>
                <li>Provide the member's Birth Date (in YYYY-MM-DD format).</li>
                <li>
                  Confirm the addition by reviewing the details and clicking the
                  "Add Member" button.
                </li>
              </ol>
            </AccordionDetails>
          </Accordion>
        </div>

        <div className="greyBoxVer">
          {(editId && member) || !editId ? (
            <AddMemberForm
              url={url}
              member={member}
              Edit={editId ? true : false}
              editId={editId}
            />
          ) : (
            <div className="loadingBox">
              <PulseLoader color={config.PRIMARY_COLOR} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default AddMember;
